import React, { useState, useEffect } from "react";
import type { IModuleProgress } from "@/apis/exam_progress/types";

interface ModuleTimerProps {
  currentModule: IModuleProgress;
}

export const ModuleTimer: React.FC<ModuleTimerProps> = ({ currentModule }) => {
  const [remainingTime, setRemainingTime] = useState<string>("");
  const [isWarning, setIsWarning] = useState(false);

  useEffect(() => {
    if (!currentModule.started_at) {
      setRemainingTime("-");
      return;
    }

    const updateTimer = () => {
      const startTime = new Date(currentModule.started_at!).getTime();
      const now = new Date().getTime();
      const elapsedMs = now - startTime;
      
      // Convert duration from minutes to milliseconds
      const durationMs = (currentModule.duration || 35) * 60 * 1000;
      const remainingMs = Math.max(0, durationMs - elapsedMs);
      
      const minutes = Math.floor(remainingMs / (60 * 1000));
      const seconds = Math.floor((remainingMs % (60 * 1000)) / 1000);
      
      // Set warning state if 5 minutes or less remain
      setIsWarning(minutes <= 5);
      
      setRemainingTime(`${minutes}:${seconds.toString().padStart(2, '0')}`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [currentModule]);

  return (
    <div className={`text-xs font-medium ${isWarning ? 'text-red-600' : 'text-gray-500'}`}>
      {remainingTime}
    </div>
  );
}; 